import {UseMutationResult, useMutation} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

export interface GetMiniTournamentPlayerCountPayload {
  tournament_id: number;
}

export interface GetMiniTournamentPlayerCountResponse {
  success: boolean;
  tournament_id?: number;
  player_count?: number;
  is_odd?: boolean;
  error?: string;
}

export default function useGetMiniTournamentPlayerCountApi(
  handleOnSuccess?: (data: GetMiniTournamentPlayerCountResponse) => void,
  handleOnError?: (error: unknown) => void,
): UseMutationResult<
  GetMiniTournamentPlayerCountResponse,
  unknown,
  GetMiniTournamentPlayerCountPayload
> {
  return useMutation<
    GetMiniTournamentPlayerCountResponse,
    unknown,
    GetMiniTournamentPlayerCountPayload
  >(
    async (payload: GetMiniTournamentPlayerCountPayload) => {
      const response = await ChessRestClient.post(
        'classroom/v1/get_mini_tournament_player_count/',
        payload,
      );
      return response.data;
    },
    {
      onSuccess: (data: GetMiniTournamentPlayerCountResponse) => {
        if (handleOnSuccess) {
          handleOnSuccess(data);
        }
      },
      onError: (error: unknown) => {
        console.error('Failed to fetch mini tournament player count:', error);
        if (handleOnError) {
          handleOnError(error);
        }
      },
    },
  );
}
